import { render, staticRenderFns } from "./Seller.vue?vue&type=template&id=40444b3e"
import script from "./Seller.vue?vue&type=script&lang=js"
export * from "./Seller.vue?vue&type=script&lang=js"
import style0 from "./Seller.vue?vue&type=style&index=0&id=40444b3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports